const paymentTypes = {
  CASH: "CS",
  CARD: "CD",
  CHECK: "CK",
  NETS: "NT",
  OTHERS: "OT",
  FOC: "FOC",
  DEPOSIT: "DPS",
  GATEWAY: "GW",
  STORE: "ST",
  STORE_AND_CARD: "SC",
};

const paymentGatewayProvider = {
  FISERV: "FS",
  STRIPE: "ST",

  EMPTY: null,
};

export { paymentTypes, paymentGatewayProvider };
